import type { SVGProps } from 'react';

const SvgRotateCounterClockwise = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 11H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2m0 8H5v-6h13zM4 9c.55 0 1-.45 1-1V5h6v3c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1m14.38-4.96.33-.33A.996.996 0 1 0 17.3 2.3l-2 2a.996.996 0 0 0 0 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.25-.25c1.43.22 2.54 1.46 2.54 2.95 0 .55.45 1 1 1s1-.45 1-1c0-2.63-2.05-4.77-4.62-4.96z"
    />
  </svg>
);
export default SvgRotateCounterClockwise;
